import { render, staticRenderFns } from "./TheENSManagerLayout.vue?vue&type=template&id=56f087a6&scoped=true"
import script from "./TheENSManagerLayout.vue?vue&type=script&lang=js"
export * from "./TheENSManagerLayout.vue?vue&type=script&lang=js"
import style0 from "./TheENSManagerLayout.vue?vue&type=style&index=0&id=56f087a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f087a6",
  null
  
)

export default component.exports